var tmAjaxActionNonce = '';
tmUtils = function () {
    return {
        showElementsForSelector: function (selector) {
            jQuery(selector).removeClass('c-hidden');
        },
        hideElementsForSelector: function (selector) {
            jQuery(selector).addClass('c-hidden');
        },
        showLoaderForSelector: function (selector) {
            jQuery(selector).addClass('c-btn-loading');
        },
        hideLoaderForSelector: function (selector) {
            jQuery(selector).removeClass('c-btn-loading');
        },
        validateEmailString: function (value) {
            let emailValidateRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return emailValidateRegex.test(value);
        },
        isTmSupportOnline: function () {
            let offset = '-4';
            var d = new Date();
            var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
            let keyWestTime = new Date(utc + (3600000*offset));

            let keyWestTimeHours = keyWestTime.getHours();
            let isCallUsTimeValid = true;
            if (keyWestTimeHours > 22 || keyWestTimeHours < 7) {
                /* closed from 10pm to 7am */
                isCallUsTimeValid = false;
            }
            return isCallUsTimeValid;
        },
        getAjaxRequestNonce: function () {
            return tmAjaxActionNonce;
        },
        // Review content (text, names, traveller photos) never sits in a page's source: it comes from admin-ajax with
        // its action in the URL, which robots.txt blocks (TmSite::addReviewsRobotsRules()), so crawlers never render it.
        reviewsUrl: function (action, params) {
            return ajaxurl + '?' + jQuery.param(jQuery.extend({ action: action }, params || {}));
        },
        getRandomId: function() {
            return Math.floor(Math.random() * 26) + Date.now()
        },
        getCurrentPlainDomain: function () {
            return location.host.replace("www.","");
        },
        isValidImageUrl: function (url, callback) {
            let img = new Image();
            img.onload = function() {
                callback(true);
            };
            img.onerror = function() {
                callback(false);
            };
            img.src = url;
        },
        isMobileOrTablet: function () {
            let ua = navigator.userAgent || navigator.vendor || window.opera;

            // iPad detection (including iPadOS 13+ where UA includes Macintosh but has touch support)
            let isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

            // Android tablet (Android without 'Mobile' in UA)
            let isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

            // General mobile (phones, iPod, etc.)
            let isMobile = /Android.+Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|webOS/i.test(ua);

            return isIpad || isAndroidTablet || isMobile;
        },
        getParameterFromUrl: function(parameter, urlValue) {
            let url = new URL(urlValue);
            return url.searchParams.get(parameter) ?? null;
        },

        /**
         *  @param {string} key - The name of the key.
         *  @param value - Value to save
         *  @param {number} ttl - Time to live in seconds, Defaults to approximately 1 year
         */
        saveToLocalStorage: function (key, value, ttl = 365 * 24 * 60 * 60) {
            const now = Date.now();

            const item = {
                value: value,
                expiry: now + (ttl * 1000), // ttl is the time-to-live in milliseconds
            };

            try {
                localStorage.setItem(key, JSON.stringify(item));
            }
            catch (e) {

            }
        },

        getFromLocalStorage: function(key) {
            try {
                const item = localStorage.getItem(key);

                if (!item) {
                    return null;
                }

                const json = JSON.parse(item);
                const now = Date.now();

                if (now > json.expiry) {
                    // If expired, remove the item and return null
                    localStorage.removeItem(key);
                    return null;
                }

                return json.value;
            }
            catch (e) {
                return null;
            }
        },

        cToolTipJsFix: function(){
            $(".c-tooltip-wrapper--js").each(function () {
                const $wrapper = $(this);
                const $tooltip = $wrapper.find(".c-tooltip-content");

                if (!$tooltip.length) return;

                const wrapperRect = this.getBoundingClientRect();
                const el = $tooltip.get(0);

                // 'tooltip-width' => 'trigger': the wrapper's width, set before the height is read (the text wraps to it)
                if ($wrapper.hasClass('c-tooltip-wrapper--trigger-width')) {
                    el.style.setProperty('--width', wrapperRect.width + 'px');
                }

                const tooltipHeight = $tooltip.outerHeight();
                const left = wrapperRect.left + (wrapperRect.width / 2);

                const top = wrapperRect.top - tooltipHeight - 10;

                el.style.setProperty('--left', left + 'px');
                el.style.setProperty('--top', top + 'px');

                // inside a transformed box (a phone bottom sheet) "fixed" counts from that box, not the window: an open
                // tooltip is moved by the difference (COOL 587)
                if ($tooltip.is(':visible')) {
                    const placed = el.getBoundingClientRect();
                    el.style.setProperty('--left', (2 * left - (placed.left + placed.width / 2)) + 'px');
                    el.style.setProperty('--top', (2 * top - placed.top) + 'px');
                }
            });
        },

        // the visitor's cookie consent for a category: 'necessary' | 'preferences' | 'analytics' | 'advertising'
        // (tm-consent.js; before it loads, what the <head> script read from tm_consent — consent-default.php)
        consentAllows: function(category) {
            try {
                if (window.TmConsent && typeof window.TmConsent.allowed === 'function') {
                    return window.TmConsent.allowed(category);
                }
                let state = window.tmConsentState;
                if (state && state.choice) {
                    return category === 'necessary' || !!state.choice[{ preferences: 'p', analytics: 'a', advertising: 'm' }[category]];
                }
            } catch (e) {}
            return category === 'necessary';
        },

        // whether a call that needs consent may go ahead now. On a first visit the region is unknown until /cdn-cgi/trace
        // answers (tm-consent.js, up to 1.5 s): then the call is not dropped but handed to TmConsent.ready(), which runs
        // `retry` once the region is known, and `retry` asks again (notice region: goes ahead; opt-in region: dropped).
        // Each deferred call runs once (ready() runs its queue once). false = not now (dropped, or deferred).
        consentReady: function(category, retry) {
            try {
                if (window.TmConsent && typeof window.TmConsent.known === 'function' && !window.TmConsent.known() && typeof retry === 'function') {
                    window.TmConsent.ready(retry);
                    return false;
                }
            } catch (e) {}
            return tmUtils.consentAllows(category);
        },

        // PostHog events: only with analytics consent
        posthogCapture: function(eventName, properties) {
            if (!tmUtils.consentReady('analytics', () => tmUtils.posthogCapture(eventName, properties))) {
                return;
            }
            try {
                window.posthog.capture(eventName, properties);
            } catch (e) {}
        },

        datalayer__pushData: function(data, retries = 50) {
            if (window.dataLayer) {
                try {
                    dataLayer.push(data);
                } catch(e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.datalayer__pushData(data, retries - 1)
                }, 200);
            }
            else {
                console.log('tmUtils.datalayer__pushData: window.dataLayer is not defined');
            }
        },

        fbqTrack: function(eventName, eventData, retries = 50) {
            if (!tmUtils.consentReady('advertising', () => tmUtils.fbqTrack(eventName, eventData, retries))) { // ad pixels: only with advertising consent (Consent banner Flow 6)
                return;
            }
            if (typeof window.fbq === 'function') {
                try {
                    window.fbq('track', eventName, eventData);
                } catch (e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.fbqTrack(eventName, eventData, retries - 1);
                }, 200);
            }
            else {
                console.log('tmUtils.fbqTrack: window.fbq is not defined');
            }
        },

        openAiTrack: function(eventName, eventData, retries = 50) {
            if (!tmUtils.consentReady('advertising', () => tmUtils.openAiTrack(eventName, eventData, retries))) { // ad pixels: only with advertising consent (Consent banner Flow 6)
                return;
            }
            if (typeof window.oaiq === 'function') {
                try {
                    oaiq("measure", eventName, eventData);
                } catch (e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.openAiTrack(eventName, eventData, retries - 1);
                }, 200);
            }
            else {
                console.log('tmUtils.ttqTrack: window.ttq is not defined');
            }
        },

        openAiUser: function(externalId, email, retries = 50) {
            if (!tmUtils.consentReady('advertising', () => tmUtils.openAiUser(externalId, email, retries))) { // ad pixels: only with advertising consent (Consent banner Flow 6)
                return;
            }
            if (typeof window.oaiq === 'function') {
                try {
                    oaiq("init", {
                        pixelId:"8oA1fXwJYNbcC34Qn4FtgD",
                        user: {
                            email_sha256: sha256(email),
                            external_id_sha256: sha256(externalId)
                        }
                    });
                } catch (e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.openAiUser(externalId, email, retries - 1);
                }, 200);
            }
            else {
                console.log('tmUtils.openAiUser: window.oaiq is not defined');
            }
        },

        // only use on confirmation page. need to add JS lib if use on other pages.
        ttqIdentify: function(externalId, email, phone, retries = 20) {
            if (!tmUtils.consentReady('advertising', () => tmUtils.ttqIdentify(externalId, email, phone, retries))) { // ad pixels: only with advertising consent (Consent banner Flow 6)
                return;
            }
            if (typeof window.ttq === 'object') {
                try {
                    ttq.identify({
                        "email": sha256(email),
                        "phone_number": sha256(phone),
                        "external_id": sha256(externalId)
                    });
                } catch (e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.ttqIdentify(externalId, email, phone, retries - 1);
                }, 200);
            }
            else {
                console.log('tmUtils.ttqTrack: window.ttq is not defined');
            }
        },

        ttqTrack: function(eventName, eventData, retries = 50) {
            if (!tmUtils.consentReady('advertising', () => tmUtils.ttqTrack(eventName, eventData, retries))) { // ad pixels: only with advertising consent (Consent banner Flow 6)
                return;
            }
            if (typeof window.ttq === 'object') {
                try {
                    ttq.track(eventName, eventData);
                } catch (e) {}
            }
            else if (retries > 0) {
                setTimeout(() => {
                    tmUtils.ttqTrack(eventName, eventData, retries - 1);
                }, 200);
            }
            else {
                console.log('tmUtils.ttqTrack: window.ttq is not defined');
            }
        },
    }
}(window);

/* Help Center - old or new */
(function() {
    jQuery(document).ready(function () {
        jQuery.post(
            ajaxurl,
            {'action': 'ajax_requests_nonce'},
            function(response) {
            if ( response !== '' ){
                tmAjaxActionNonce = response;
                jQuery(document).trigger('tmAjaxRequestNonceLoaded');
            }
        });
    });
})();

/* Exit Intent detected */
jQuery(function ($) {
    $(document).on('mouseout', function (e) {
        if (
            !e.relatedTarget &&
            !e.toElement &&
            e.clientY <= 10
        ) {
            jQuery(document).trigger('userExitIntentDetected');
        }
    });
});
window.addEventListener('popstate', function () {
    jQuery(document).trigger('userExitIntentDetected');
});
